import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { FormGroup, FormControl, FormArray, FormBuilder } from '@angular/forms';
import { ObjectType } from 'src/app/data/constants/object-type.enum';
import { BannerMessageVariant, ButtonVariant, IOptionProps } from '@amobee/component-library';
import { MessageService } from '../../../../../services/message.service';
import { FileUploaderService } from 'src/app/services/file-uploader.service';
import { S3 } from 'aws-sdk';
import { CreativeAdapter } from 'src/adapters/creative-adapter';
import { CreativeVO } from 'src/app/data/vo/CreativeVO';
import { LanguageConst } from 'src/app/data/constants/language.const';
import { CreativeDTO } from 'src/app/data/dto/CreativeDTO';
import { DurationConst } from 'src/app/data/constants/duration.const';
import { IFooterProp } from 'src/app/common/components/footer/footer.component';
import { fromEvent } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'video-list',
  templateUrl: './video-list.component.html',
  styleUrls: ['./video-list.component.scss']
})

export class VideoListComponent implements OnInit {

  @Input() isCreativeRename: boolean;
  @Input() selectedLanguage: Array<string>;
  @Input() selectedVideoOptions: Array<any>;
  @Input() backToCampaignId: string;

  @Output("backToVideoProduce")
  backToVideoProduce: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('creativeResultReportTemplate', { static: true }) public creativeResultReportTemplate: TemplateRef<any>;
  @ViewChild('creativeUploadReportTemplate', { static: true }) public creativeUploadReportTemplate: TemplateRef<any>;

  languages: Array<any> = [];
  durations: Array<any> = [];
  uploadResults: Array<any> = [];
  selectedFiles: Array<File> = [];
  newFiles: Array<File> = [];
  errorFiles: Array<any> = [];
  tempVideoDurationMap: Array<any> = [];
  creatives: FormArray = new FormArray([]);
  creativesToSave: Array<CreativeVO> = [];
  savedCreatives: Array<CreativeVO> = [];
  isNew: boolean = true;
  objectTypeEnum: any = ObjectType;
  DurationConst = DurationConst;
  myVideos = [];
  showCreativePayment: boolean = false;
  creativeIds: any = [];
  totalPrice: number = 0;
  backingToCampaignPage: boolean = false;
  windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  durationMessage: string = '';
  footerButtonsForNewCreative: Array<IFooterProp> = [
    {
      variant: ButtonVariant.NEUTRAL,
      label: 'Cancel',
      onClick: () => {
        this.backToList();
      }
    },
    {
      variant: ButtonVariant.PRIMARY,
      label: 'Upload Creatives',
      isDisabled: () => this.selectedFiles.length === 0,
      onClick: () => {
        this.validateAndSave();
      }
    }
  ];
  footerButtonsForNameCreative: Array<IFooterProp> = [
    {
      variant: ButtonVariant.NEUTRAL,
      label: 'Cancel',
      onClick: () => {
        this.backToList();
      },
      isDisabled: () => this.backingToCampaignPage,
      showIcon: () => this.backingToCampaignPage ? "Process" : null,
      iconPosition: "right",
    },
    {
      variant: ButtonVariant.NEUTRAL,
      label: 'Back',
      onClick: () => {
        this.backToPreviousPage();
      }
    },
    {
      variant: ButtonVariant.PRIMARY,
      label: 'Purchase Creatives',
      onClick: () => {
        this.switchToPurchase();
      },
      isDisabled: () => this.disabledPurchaseBtn
    }
  ];
  disabledPurchaseBtn: boolean = false;

  constructor(private modal: ModalService,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private fileUploaderService: FileUploaderService,
    private creativeAdapter: CreativeAdapter,
    private fb: FormBuilder) { }

  ngOnInit() {
    this.messageService.sendFormTitle(['Add Creatives', false]);
    _.forEach(LanguageConst, (value: any) => {
      this.languages.push(value);
    });

    if (this.isCreativeRename) {
      // always reset total price before calculation
      this.totalPrice = 0;
      for (var videoOption of this.selectedVideoOptions) {
        this.updateCreativesBaseOnVideoLengthAndQuality(videoOption);
      }
    }

    _.forEach(DurationConst, (value: any) => {
      this.durations.push(value);
    });
    this.updateDurationMessage();

    this.creativeAdapter.getAdDurations().then((adDurations: any) => {
      let tmpDurations = [];
      adDurations.forEach(adDuration => {
        if (adDuration.device_formats.includes('TV_LINEAR')) {
          tmpDurations.push({ value: adDuration.min_length_seconds, label: adDuration.min_length_seconds + ' Seconds' });
        }
      });
      this.durations = tmpDurations;
      this.updateDurationMessage();
    });
  }

  updateDurationMessage() {
    this.durationMessage = 'Ads must be of ';
    for (var index in this.durations) {
      if (+index < this.durations.length - 2) {
        this.durationMessage = this.durationMessage + this.durations[index].value + 's, ';
      } else if (+index == this.durations.length - 2) {
        this.durationMessage = this.durationMessage + this.durations[index].value + 's or ';
      } else {
        this.durationMessage = this.durationMessage + this.durations[index].value + 's. ';
      }
    }
  }

  updateCreativesBaseOnVideoLengthAndQuality(videoOption: any) {
    var i: number = 0
    while (i < videoOption.quantity) {
      i++;
      for (var language of this.selectedLanguage) {
        var creative = this.getCreative();
        var type = i + ' - ' + ((videoOption.creative_product_id === 1 || videoOption.creative_product_id === 3) ? 'Client' : 'Mediacorp')
          + " Motion Graphics Video - " + videoOption.length + " Sec - " + language;
        var name = "YOUR_NAME_HERE_" + i + " - " + ((videoOption.creative_product_id === 1 || videoOption.creative_product_id === 3) ? 'Client' : 'Mediacorp')
          + " Motion Graphics Video " + videoOption.length + " Sec - " + language;
        creative.controls['language'].patchValue(language);
        creative.controls['adDuration'].patchValue(videoOption.length);
        creative.controls['creativeAuthor'].patchValue("Seller");
        creative.controls['creative_product_id'].patchValue(videoOption.creative_product_id);
        creative.controls['name'].patchValue(name);
        creative.controls['type'].patchValue(type);
        (((creative.controls['creativeFormats'] as FormGroup).controls[0]) as FormGroup).controls['cdnUrl'].patchValue(null);
        (((creative.controls['creativeFormats'] as FormGroup).controls[0]) as FormGroup).controls['formatType'].patchValue("MXF");
        this.creatives.push(creative);
        this.totalPrice = this.totalPrice + videoOption.price;
      }
    }
  }

  processFiles(files: File[]) {
    let allPromises: Array<Promise<any>> = [];
    for (let file of Array.from(files)) {
      if (file.size > 2147483648) {
        this.modal.error({
          message: 'File: ' + file.name + ' is too large',
          subMessage: 'please select video less than 2G.'
        });
        continue;
      }
      var fileTypeOnWindows;
      if (this.windowsPlatforms.indexOf(window.navigator.platform) !== -1) {
        fileTypeOnWindows = file.name.split('.').pop();
      }
      if (!(file.type === "application/mxf" || file.type === "video/mp4" || fileTypeOnWindows === "mxf")) {
        this.modal.error({
          message: 'Format not support for File: ' + file.name,
          subMessage: 'Please select video with .mxf or .mp4 format.'
        });
        continue;
      }
      if (file.name.length > 128) {
        Object.defineProperty(file, 'name', {
          writable: true,
          value: file.name.substring(0, 128)
        });
      }
      if (file.type === "video/mp4") {
        let video = document.createElement('video');
        video.preload = 'metadata';
        video.src = URL.createObjectURL(file);
        video.onloadedmetadata = () => {
          window.URL.revokeObjectURL(video.src);
          let hasCorrespondingDuration = false;
          this.durations.forEach(duration => {
            if (duration.value == 5 || duration.value == 6 || duration.value == 7) {
              if (video.duration > duration.value * 0.95 && video.duration < duration.value * 1.05) {
                this.tempVideoDurationMap.push({ name: file.name, duration: duration.value });
                hasCorrespondingDuration = true;
              }
            } else {
              if (video.duration > duration.value * 0.9 && video.duration < duration.value * 1.1) {
                this.tempVideoDurationMap.push({ name: file.name, duration: duration.value });
                hasCorrespondingDuration = true;
              }
            }
          });
          if (!hasCorrespondingDuration) {
            this.errorFiles.push({ name: file.name, duration: video.duration });
          }
        }
        allPromises.push(fromEvent(video, 'loadedmetadata').pipe(take(1)).toPromise());
      }
      this.newFiles.push(file);
    }
    this.isNew = false;
    Promise.all(allPromises).then(() => {
      if (this.errorFiles.length != 0) {
        let message = '';
        for (var errorFile of this.errorFiles) {
          message = message + 'The selected video: ' + errorFile.name
            + ' has a duration that is not supported: ' + errorFile.duration + 's' + '\n';
        }
        let subMessage = 'Please select video around ';
        for (var index in this.durations) {
          if (+index < this.durations.length - 1) {
            subMessage = subMessage + this.durations[index].value + 's, ';
          } else {
            subMessage = subMessage + this.durations[index].value + 's. ';
          }
        }
        this.modal.error({
          message: message,
          subMessage: subMessage
        });
      }

      this.newFiles = this.newFiles.filter(file =>
        this.errorFiles.every(errorFile => errorFile.name !== file.name));
      this.errorFiles = [];
      for (let file of this.newFiles) {
        this.selectedFiles.push(file);
      }
      this.createCreatives();
    });
  }


  createCreatives() {
    for (let i = 0; i < this.newFiles.length; i++) {
      let creative = this.getCreative();
      creative.controls['name'].patchValue(this.newFiles[i].name);
      (((creative.controls['creativeFormats'] as FormGroup).controls[0]) as FormGroup).controls['cdnUrl'].patchValue(null);
      if (this.windowsPlatforms.indexOf(window.navigator.platform) !== -1 && this.newFiles[i].name.split('.').pop() === 'mxf') {
        (((creative.controls['creativeFormats'] as FormGroup).controls[0]) as FormGroup).controls['formatType'].patchValue("MXF");
      } else {
        (((creative.controls['creativeFormats'] as FormGroup).controls[0]) as FormGroup).controls['formatType'].patchValue
          (this.newFiles[i].type === 'application/mxf' ? 'MXF' : this.newFiles[i].type === 'video/mp4' ? 'MP4' : '');
      }
      creative.controls['creativeAuthor'].patchValue("Buyer");
      if (this.tempVideoDurationMap.some(file => file.name === this.newFiles[i].name)) {
        creative.controls['adDuration'].patchValue(this.tempVideoDurationMap.find(f => f.name === this.newFiles[i].name).duration);
      }
      this.creatives.push(creative);

    }
    this.tempVideoDurationMap = [];
    this.newFiles = [];
  }

  backToList() {
    if (this.backToCampaignId) {
      this.backingToCampaignPage = true;
      this.router.navigate(['campaign/edit', this.backToCampaignId], { queryParams: { "fromCreative": true } }).catch((e) => {
        this.backingToCampaignPage = false;
      });
    } else {
      this.router.navigate([ObjectType.Creative, 'list']);
    }
  }

  validateAndSave() {
    if (this.creatives.length === 0) {
      this.modal.error({
        message: 'Please upload at least one video',
        subMessage: ''
      });
    } else if (this.creatives.invalid) {
      this.modal.error({
        message: 'Name, Language, and Duration are required for each creative.'
      });
    } else {
      this.modal.confirmation({
        message: `Uploading ${this.selectedFiles.length} ${this.selectedFiles.length > 1 ? 'creatives' : 'creative'}. Do you wish to continue?`,
        subMessage: 'Click OK to continue, or click Cancel to stay on this page.'
      },
        'Confirm Creative Upload',
        'OK',
        () => {
          this.uploadFiles();
        });
    }
  }

  creativeDtoToVo() {
    for (var creativeVo of this.creatives.value) {
      this.creativesToSave.push(creativeVo);
    }
    console.log(this.creativesToSave);
  }

  uploadFiles() {
    let inProgressReport = Array(this.creatives.length).fill('');
    let ref;
    this.fileUploaderService.uploadFiles(this.selectedFiles, (data: Array<S3.ManagedUpload.SendData | null>) => {
      let success: string[] = [];
      let failure: string[] = [];
      let creativesToSave: CreativeVO[] = [];
      data.forEach((d, index: number) => {
        if (d) {
          this.creativeCdnUrl(index).patchValue(d.Location);
          success.push(this.creativeName(index).value);
          creativesToSave.push(this.creative(index).value);
        } else {
          failure.push(this.creativeName(index).value);
        }
      });
      if (success.length > 0) {
        this.creativeAdapter.createCreative(creativesToSave).then((result: CreativeVO[]) => {
          this.reportCreativeUploadResult(ref, success, failure);
          this.fileUploaderService.sendNotification();
        }, (error: any) => {
          // this should rarely happen due to api failure, but still have logic to handle in case if it happens
          this.reportCreativeUploadResult(ref, [], []);
          this.messageService.sendNotification('An error occurs when saving the uploaded creatives.', BannerMessageVariant.ERROR, 0, false);
        });
      } else {
        this.reportCreativeUploadResult(ref, success, failure);
      }
    }).then((allUploads: Array<S3.ManagedUpload>) => {
      allUploads.forEach((upload: S3.ManagedUpload, index: number) => {
        upload.on('httpUploadProgress', (progress: S3.ManagedUpload.Progress) => {
          let percent = progress.loaded / progress.total * 100;
          inProgressReport[index] = this.creativeName(index).value + ': ' + percent.toFixed(2) + '%';
        });
        inProgressReport[index] = this.creativeName(index).value + ': 0.00%';
      });
      ref = this.messageService.sendNotificationCustomHtml({ templateRef: this.creativeUploadReportTemplate, scopeValue: { value: inProgressReport } }, BannerMessageVariant.WARNING, 0, true, false);
      this.router.navigate([ObjectType.Creative, 'list']);
    });
  }

  reportCreativeUploadResult(ref: any, success: string[], failure: string[]) {
    if (ref) {
      this.messageService.removeNotification(ref);
    }
    if (success.length > 0) {
      let report = {
        creatives: success,
        isSuccess: true
      };
      this.messageService.sendNotificationCustomHtml({ templateRef: this.creativeResultReportTemplate, scopeValue: report }, BannerMessageVariant.SUCCESS, 0, false);
    }
    if (failure.length > 0) {
      let report = {
        creatives: failure,
        isSuccess: false
      };
      this.messageService.sendNotificationCustomHtml({ templateRef: this.creativeResultReportTemplate, scopeValue: report }, BannerMessageVariant.ERROR, 0, false);
    }
  }

  handleLanguageChange($event: IOptionProps, index) {
    this.creativeLanguage(index).patchValue($event.value);
  }

  handleDurationChange($event: IOptionProps, index) {
    this.creativeDuration(index).patchValue($event.value);
  }

  switchToPurchase() {
    this.disabledPurchaseBtn = true;
    // currently CreativeVO should match with CreativeDTO
    let creativesToSave: CreativeVO[] = this.creatives.value;
    this.creativeAdapter.createCreative(creativesToSave).then((res: CreativeVO[]) => {
      this.savedCreatives = res;
      this.showCreativePayment = true;
      this.disabledPurchaseBtn = false;
    }).catch((error) => {
      this.disabledPurchaseBtn = false;
    });
  }

  backToRenameCreative() {
    this.showCreativePayment = false;
    this.messageService.sendFormTitle(['Add Creatives', false]);
  }

  getCreative(): FormGroup {
    return new CreativeDTO(this.fb).formGroup;
  }

  creative(index): FormGroup {
    return (this.creatives.controls[index]) as FormGroup
  }

  creativeName(index): FormControl {
    return this.creative(index).controls.name as FormControl;
  }

  creativeLanguage(index): FormControl {
    return this.creative(index).controls.language as FormControl;
  }

  creativeDuration(index): FormControl {
    return this.creative(index).controls.adDuration as FormControl;
  }

  creativeAuthor(index): FormControl {
    return this.creative(index).controls.creativeAuthor as FormControl;
  }

  creativeFormat(index): FormGroup {
    return (this.creative(index).controls.creativeFormats as FormGroup).controls[0] as FormGroup;
  }

  creativeFormatType(index): FormControl {
    return this.creativeFormat(index).controls.formatType as FormControl;
  }

  creativeCdnUrl(index): FormControl {
    return this.creativeFormat(index).controls.cdnUrl as FormControl;
  }

  backToPreviousPage() {
    this.backToVideoProduce.emit();
  }

  getCreativeDuration(index) {
    let duration: Number = this.creativeDuration(index).value;
    if (duration) {
      return Object.values(this.durations).find((v) => {
        return v.value == duration.toString();
      })
    } else {
      return undefined;
    }
  }

}
